import React from 'react';
import { Button } from '../../Button/button';
import './TabContent.css';

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirm Deletion",
    message = "Are you sure you want to delete this item?",
    confirmText = "Delete",
    cancelText = "Cancel",
    type = "danger"
}) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '2rem',
                maxWidth: 400,
                width: '90%',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                textAlign: 'center'
            }}>
                <div style={{
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    color: type === 'danger' ? '#dc3545' : '#333',
                    marginBottom: '1rem'
                }}>
                    {title}
                </div>

                <div style={{
                    fontSize: '1rem',
                    color: '#666',
                    marginBottom: '2rem',
                    lineHeight: 1.5
                }}>
                    {message}
                </div>

                <div style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'center'
                }}>
                    <Button
                        buttonStyle="btn--outline"
                        buttonSize="btn--medium"
                        onClick={onClose}
                        style={{
                            minWidth: 100,
                            borderColor: '#ddd',
                            color: '#666'
                        }}
                    >
                        {cancelText}
                    </Button>

                    <Button
                        buttonStyle={type === 'danger' ? 'btn--danger' : 'btn--primary'}
                        buttonSize="btn--medium"
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        style={{
                            minWidth: 100
                        }}
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal; 